// extracted by mini-css-extract-plugin
export default {"productGrid":"CY-z","centerLink":"DY-z","productSection":"EY-z","item":"FY-z","ctaButton":"GY-z"};